export const SHARING_LOADING = "SHARING_LOADING";
export const SHARING_ERROR = "SHARING_ERROR";
export const SHARING_GET = "SHARING_GET";
export const SHARING_GET_FILTERS = "SHARING_GET_FILTERS";
export const SHARING_ADD = "SHARING_ADD";
export const SHARING_UPDATE = "SHARING_UPDATE";
export const SHARING_DELETE = "SHARING_DELETE";



// WEBPACK FOOTER //
// ./src/actions/sharing/constants.js